import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skull, Loader2 } from "lucide-react";

const TAPE_IMG = "https://images.pexels.com/photos/18527687/pexels-photo-18527687.jpeg";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const forgot = async () => {
    try {
      await api.post("/auth/forgot", { origin_url: window.location.origin });
      setForgotSent(true);
      toast.success("Pokud účet existuje, poslali jsme odkaz na e-mail majitele.");
    } catch (e) { toast.error("Nepodařilo se odeslat."); }
  };

  useEffect(() => {
    if (localStorage.getItem("vodnice_token")) {
      api.get("/auth/me").then(() => nav("/admin/dashboard" + window.location.search)).catch(() => localStorage.removeItem("vodnice_token"));
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("vodnice_token", data.token);
      toast.success("Přihlášení úspěšné.");
      nav("/admin/dashboard" + window.location.search);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Přihlášení selhalo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-[#050505] flex items-center justify-center relative overflow-hidden">
      <img src={TAPE_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-black/70 scanlines" />
      <form onSubmit={submit} className="relative z-30 w-full max-w-sm border border-white/10 bg-[#0a0a0a]/90 p-8 border-t-2 border-t-red-700">
        <div className="flex items-center gap-2 justify-center mb-6">
          <Skull className="w-6 h-6 text-red-600" />
          <h1 className="font-head text-xl uppercase tracking-widest text-neutral-100">Admin přístup</h1>
        </div>
        <div className="mb-4">
          <Label className="text-xs text-neutral-400">Uživatelské jméno</Label>
          <Input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)}
            className="rounded-none bg-[#111] border-white/10 focus-visible:ring-red-700 mt-1" />
        </div>
        <div className="mb-6">
          <Label className="text-xs text-neutral-400">Heslo</Label>
          <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="rounded-none bg-[#111] border-white/10 focus-visible:ring-red-700 mt-1" />
        </div>
        <Button data-testid="admin-login-btn" disabled={loading} type="submit"
          className="vhs-btn w-full rounded-none bg-red-700 hover:bg-red-600 text-white font-head tracking-widest py-6">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "PŘIHLÁSIT SE"}
        </Button>
        <button type="button" onClick={forgot} data-testid="forgot-password-btn"
          className="block w-full text-center text-xs text-neutral-500 hover:text-red-500 mt-4 tracking-widest">
          {forgotSent ? "ODKAZ ODESLÁN NA E-MAIL MAJITELE" : "ZAPOMNĚLI JSTE HESLO?"}
        </button>
        <a href="/" className="block text-center text-xs text-neutral-600 hover:text-red-500 mt-3 tracking-widest">← ZPĚT NA WEB</a>
      </form>
    </div>
  );
}
